import { HttpError } from "./HttpError";

/** Error HTTP 400/422 (validación de la petición). */
export class ValidationError extends HttpError {
  /** @param message Mensaje de error. */
  constructor(message: string) {
    super(message, 400);
  }
}
